import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { EffectPlaceCian } from 'shared/components/EffectPlaceCian';
import { selectDealType } from 'shared/selectors/dealType';
import { selectOfferType } from 'shared/selectors/offerType';

export const EffectPlaceCianContainer: React.FC = () => {
  const offerType = useSelector(selectOfferType);

  const dealType = useSelector(selectDealType);

  const device = useDeviceType();

  return <EffectPlaceCian offerType={offerType} dealType={dealType} device={device} />;
};
